import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const QuoteCTASection = () => {
  return (
    <div className=" p-3 ">
      <div className="flex md:flex-row md:justify-between items-center flex-col gap-6">
        <div className="flex flex-col md:items-start items-center gap-4">
          <h2 className="text-lg font-bold text-n-green">
            Ainda não agendou o seu transporte?
          </h2>
          <p className="text-base text-n-green font-medium">
            Faça uma cotação agora mesmo!
          </p>

          <Link to="/fazer-cotacao" className="mt-4">
            <Button className="flex items-center gap-2 px-8 py-3 text-lg font-semibold rounded-full">
              Fazer cotação
              <ArrowRight className="h-5 w-5" />
            </Button>
          </Link>
        </div>

        <div className="flex md:items-start items-center mt-6">
          <img
            src="/images/customer/truck.png"
            alt="Caminhão Nacional Go"
            className="w-[250px] md:w-[300px] h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};
